import Vue from 'vue'

Vue.component('vue-menu-secondary-links', {
  template: '#vue-menu-secondary-links-template',
  props: { links: Array, type: String },
})
